export default __webpack_public_path__ + "img/dNjoFRnP.43d56f60.svg";